/* eslint-disable react-native/no-inline-styles */
/* eslint-disable-next-line react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { formInputTextError } from '@assets/styles/formStyles';
import SociollaText from '@components/sociolla/SociollaText';
import PropTypes from 'prop-types';

const propTypes = {
  hasError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

const defaultProps = {
  hasError: false,
};

const FormError = (props) => {
  const { hasError } = props;

  return (
    <>
      {hasError ? (
        <SociollaText style={formInputTextError}>{hasError}</SociollaText>
      ) : (
        false
      )}
    </>
  );
};

FormError.propTypes = propTypes;
FormError.defaultProps = defaultProps;

export default React.memo(FormError, (prev, next) => prev == next);
